import React from "react"
import ThemeContext from "../context/ThemeContext"
import { Link } from "gatsby"
import Seo from "../components/Frontend/Seo"
import FooterDefault from "../components/Footer"
import logo from "../../static/logo/logo.svg"
import "antd/dist/antd.less"
import "./AuthLayout.less"

const AuthLayout = ({ children }) => {
  return (
    <ThemeContext.Consumer>
      {() => {
        return (
          <div>
            <Seo title={`Authentication`} description={``} />
            <div className="authContainer">
              <div className="content">
                <div className="top">
                  <div className="header">
                    <Link to="/">
                      <img
                        alt="Websitecafe Learning"
                        className="logo"
                        src={logo}
                        width="171"
                        height="55"
                      />
                    </Link>
                  </div>
                  <div className="desc">
                    Websitecafe Learning Experience Platform
                  </div>
                </div>
                {children}
              </div>
              <FooterDefault />
            </div>
          </div>
        )
      }}
    </ThemeContext.Consumer>
  )
}

export default AuthLayout
